import React from 'react'

export const IconLogout = (props={}) => {
	const { size=20, imgSize=20 } = props
	return <>
		<svg width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${imgSize} ${imgSize}`} stroke="currentColor" fill="currentColor" strokeWidth="0" xmlns="http://www.w3.org/2000/svg">
			<path d="M6.00012 2V6H7.0001V3H13.6668V13H7.0001V10H6.00012V14H14.6668V2H6.00012ZM10.6668 8.5V7.5H2.20712L4.04046 5.66667L3.33346 4.96L0.293457 8L3.33346 11.0403L4.04046 10.3333L2.20712 8.5H10.6668Z" />			
		</svg>
	</>
}
